export function getAmount(value = 0) {
  let emolumentsFixe = null;
  let emolumentsPct = null;
  if (value <= 6150) {
    emolumentsFixe = 55.35;
  } else if (value <= 50000) {
    emolumentsPct = 0.9 / 100;
  } else if (value <= 100000) {
    emolumentsPct = 0.8 / 100;
  } else if (value <= 300000) {
    emolumentsPct = 0.5 / 100;
  } else if (value <= 750000) {
    emolumentsPct = 0.4 / 100;
  } else if (value <= 1250000) {
    emolumentsPct = 0.3 / 100;
  } else {
    emolumentsPct = 0.1 / 100;
  }

  const emoluments = emolumentsFixe || value * emolumentsPct;
  const tva = emoluments * 0.20;
  const conservation = 27;
  const total = emoluments + tva + conservation;
  return total;
}

export function format(number) {
  return number
    .toLocaleString('fr')
    .replace(/,[0-9]+/, str => {
      let res = str.slice(0, 3);
      if (res.length === 2) {
        res += '0';
      }
      return res;
    }) + ' €';
}

export function getAmountInCents(v) {
  return Math.round(getAmount(v) * 100);
}



/** WEBPACK FOOTER **
 ** ./shared/emoluments.js
 **/